<template>
  <card title="交易流转统计" v-if="userEqui == 'pc'">
    <div class="transaction-flow">
      <div class="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <LSTopLeft></LSTopLeft>
          </el-col>
          <el-col :span="12">
            <LSTopRight></LSTopRight>
          </el-col>
        </el-row>
      </div>
      <div class="bottom">
        <el-row :gutter="20">
          <el-col :span="8">
            <bottom-left></bottom-left>
          </el-col>
          <el-col :span="8">
            <bottom-center></bottom-center>
          </el-col>
          <el-col :span="8">
            <bottom-right></bottom-right>
          </el-col>
        </el-row>
      </div>
    </div>
  </card>
  <card title="交易流转统计" v-else>
    <div class="transaction-flow-web" :style="{ width: equiWidth - 40 + 'px' }">
      <div class="top-web">
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <LSTopLeft></LSTopLeft>
          </el-col>
          <el-col :span="12">
            <LSTopRight></LSTopRight>
          </el-col>
        </el-row> -->
        <div style="height: 350px; padding-bottom: 20px">
          <LSTopLeft></LSTopLeft>
        </div>
        <div style="height: 350px">
          <LSTopRight></LSTopRight>
        </div>
      </div>
      <div class="bottom-web">
        <!-- <el-row :gutter="20">
          <el-col :span="8">
            <bottom-left></bottom-left>
          </el-col>
          <el-col :span="8">
            <bottom-center></bottom-center>
          </el-col>
          <el-col :span="8">
            <bottom-right></bottom-right>
          </el-col>
        </el-row> -->
        <div style="height: 332px;padding-bottom: 20px;">
          <bottom-left></bottom-left>
        </div>
        <div style="height: 332px;padding-bottom: 20px;">
          <bottom-center></bottom-center>
        </div>
        <div style="height: 332px">
          <bottom-right></bottom-right>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Card from "@/components/Card/index.vue";
import LSTopLeft from "./LSTopLeft.vue";
import LSTopRight from "./LSTopRight.vue";

import bottomLeft from "../../productionService/components/landTrustSubpage/bottomLeft.vue";
import bottomCenter from "../../productionService/components/landTrustSubpage/bottomCenter.vue";
import bottomRight from "../../productionService/components/landTrustSubpage/bottomRight.vue";

export default {
  components: {
    Card,
    LSTopLeft,
    LSTopRight,
    bottomLeft,
    bottomCenter,
    bottomRight,
  },
  data() {
    return {
      userEqui: sessionStorage.getItem("equiType"), //设备类型 参数为web或pc
      equiWidth: sessionStorage.getItem("equiWidth"), //设备宽度 参数为用户当前设备的实际宽度（单位：px）
    };
  },
};
</script>

<style lang="less">
.transaction-flow {
  .top {
    height: 376px;
    margin-bottom: 15px;
  }

  .bottom {
    height: 332px;
  }

  .el-row,
  .el-col {
    height: 100%;
  }
}
.transaction-flow-web {
  padding: 0 20px 0;
  .top-web {
    // height: 376px;
    margin-bottom: 15px;
  }

  .bottom-web {
    // height: 332px;
  }

  .el-row,
  .el-col {
    height: 100%;
  }
}
</style>
